window.onload = function() {
    const FeaturedCollectionUX = () => {
        if ($('.section-laika-featured-collection').length <= 0) return null;

        $('.section-laika-featured-collection').each(function() {
            const $parent = $(this);
            const $slider = $parent.find('.lfc-slider');
            const $prevArrow = $parent.find('.custom-slider-arrow.prev');
            const $nextArrow = $parent.find('.custom-slider-arrow.next');
            const $artifactToggles = $parent.find('.artifact-toggle');
            const $ctaButtons = $parent.find('.product-detail .primary-btn');

            const slickOptions = {
                slidesToShow: 4,
                slidesToScroll: 1,
                infinite: true,
                dots: false,
                arrows: true,
                prevArrow: $prevArrow,
                nextArrow: $nextArrow,
                rows: 0,
                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 800,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 640,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            }

            $slider.slick(slickOptions);

            $artifactToggles.click(function() {
                $(this).toggleClass('active');
                $(this).closest('.col-inner').find('.artifact-details').stop().fadeToggle();
            });

            $ctaButtons.on('mouseenter', function() {
                const $theBtn = $(this); 
                $theBtn.find('.btn-text').css('display', 'none');
                $theBtn.find('.product-price').css('display', 'block');
            }).on('mouseleave', function() {
                const $theBtn = $(this); 
                $theBtn.find('.product-price').css('display', 'none');
                $theBtn.find('.btn-text').css('display', 'block');
            });
        });

        // Make the slider visible and start the animation after initializing it
        $('.section-laika-featured-collection').css('visibility', 'visible');
    };

    // Call the function to initialize the slider
    FeaturedCollectionUX();
};
